import Script from "next/script";

const RichText = ({text, isScript, hasSource, priority, source, scriptId}) => {
        
    return (
        <>
            {isScript ?
                hasSource ? 
                    <Script 
                        strategy={priority ? 'beforeInteractive' : 'afterInteractive'}
                        src={source}
                    />
                    :
                    <Script
                        strategy={priority ? 'beforeInteractive' : 'afterInteractive'}
                        id={scriptId}
                    >
                        {` ${text} `}
                    </Script>
                :
                <div dangerouslySetInnerHTML={{__html: text}} />
            }
        </>       
    )
};

export default RichText;